// quiz.js v1.5 (2026-05-23 audit-fix)
// Changes from v1.4:
//   - REAL fix for "stained glass shows charcoal/painting" — visually verified every Q3 hero
//   - golden_retriever.stained_glass: replaced charcoal with verified SG canvas
//   - rottweiler.stained_glass: replaced dead 404 with verified SG canvas
//   - german_shepherd / labrador / siberian_husky: removed broken SG entries
//     (no real SG canvas product exists yet — code falls back to GR's correct SG image)
//   - Eager-load first 6 breed tiles so they aren't gray boxes on first paint

const TQ_STATE_KEY = 'tritan_quiz_v1_state';
const KLAVIYO_PUB_KEY = 'WrADXr';
const KLAVIYO_LIST_ID = 'Tve6BY';

// Breed tile photos (Q1). Unsplash for the 4 breeds where dog.ceo had framing issues; dog.ceo for the rest.
const tqBreedPhotos = {
  australian_shepherd: 'https://images.dog.ceo/breeds/australian-shepherd/pepper.jpg',
  beagle:              'https://images.dog.ceo/breeds/beagle/n02088364_8443.jpg',
  boston_terrier:      'https://images.dog.ceo/breeds/terrier-boston/bostonterrier_000001.jpg',
  corgi:               'https://images.dog.ceo/breeds/pembroke/n02113023_15576.jpg',
  dachshund:           'https://images.dog.ceo/breeds/dachshund/dachshund-2033796_640.jpg',
  english_bulldog:     'https://images.dog.ceo/breeds/bulldog-english/bunz.jpg',
  french_bulldog:      'https://images.dog.ceo/breeds/bulldog-french/hunghung.jpg',
  german_shepherd:     'https://images.unsplash.com/photo-1589941013453-ec89f33b5e95?w=500&h=500&fit=crop&auto=format&q=80',
  golden_retriever:    'https://images.unsplash.com/photo-1633722715463-d30f4f325e24?w=500&h=500&fit=crop&auto=format&q=80',
  labrador:            'https://images.unsplash.com/photo-1605897472359-85e4b94d685d?w=500&h=500&fit=crop&auto=format&q=80',
  poodle:              'https://images.dog.ceo/breeds/poodle-standard/n02113799_4248.jpg',
  rottweiler:          'https://images.dog.ceo/breeds/rottweiler/n02106550_12760.jpg',
  siberian_husky:      'https://images.unsplash.com/photo-1605568427561-40dd23c2acea?w=500&h=500&fit=crop&auto=format&q=80',
  boxer:               'https://images.dog.ceo/breeds/boxer/n02108089_2360.jpg',
  border_collie:       'https://images.dog.ceo/breeds/collie-border/n02106166_1284.jpg',
  pug:                 'https://images.dog.ceo/breeds/pug/n02110958_14647.jpg',
  great_dane:          'https://images.dog.ceo/breeds/dane-great/n02109047_11178.jpg',
  shih_tzu:            'https://images.dog.ceo/breeds/shihtzu/n02086240_6269.jpg',
};

// Q3 style tiles: curated single-breed canvas per breed per style. CANVAS ONLY — no mugs, no multi-breed.
// Scanned from live Shopify catalog with filters: canvas product_type + single-breed title + style match.
// For acrylic, "Coastal Cliffside" or similar variants are prioritized (per Kyle's pick).
const tqStyleHeroes = {
  golden_retriever: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/golden-retriever-painting-canvas-wall-art-dog-lover-gift-pet-art-print-dog-mom-decor-acrylic-style-stretched-canvas.jpg?v=1784734281',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/12601688634700169544_2048.jpg?v=1784845468',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/golden-retriever-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-golden-retriever-lover-gift-stretched-canvas.jpg?v=1784733035',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/golden-retriever-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-golden-retriever-lover-gift-stretched-canvas.jpg?v=1784732471'
  },
  french_bulldog: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/french-bulldog-canvas-wall-art-print-dog-lover-gift-pet-portrait-home-decor-modern-acrylic-painting-dog-mom-gift.jpg?v=1784733724',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/french-bulldog-oil-portrait-stretched-canvas-frenchie-wall-art-decor-warm-dog-art-print-pet-lover-gift.jpg?v=1784731265',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/french-bulldog-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-french-bulldog-lover-gift-stretched-canvas.jpg?v=1784733011',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/french-bulldog-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-french-bulldog-lover-gift-stretched-canvas.jpg?v=1784732448'
  },
  siberian_husky: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/siberian-husky-acrylic-painting-canvas-wall-art-dog-lover-gift-pet-portrait-print-modern-home-decor-stretched-canvas-art.jpg?v=1784733574',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/siberian-husky-oil-portrait-canvas-wall-art-regal-husky-dog-lover-gift-pet-art-print-home-decor.jpg?v=1784731005',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/siberian-husky-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-siberian-husky-lover-gift-stretched-canvas.jpg?v=1784732627',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/siberian-husky-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-siberian-husky-lover-gift-stretched-canvas.jpg?v=1784732076'
  },
  german_shepherd: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/german-shepherd-acrylic-painting-canvas-print-gsd-dog-lover-wall-art-pet-portrait-gift-ready-to-hang-home-decor-for-dog-moms-dads.jpg?v=1784733711',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/3140477568582470041_2048.jpg?v=1784845280',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/german-shepherd-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-german-shepherd-lover-gift-stretched-canvas.jpg?v=1784732710',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/german-shepherd-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-german-shepherd-lover-gift-stretched-canvas.jpg?v=1784732157'
  },
  labrador: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/labrador-retriever-acrylic-painting-canvas-wall-art-dog-lover-gift-pet-portrait-home-decor-animal-art-print.jpg?v=1784733685',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/labrador-retriever-art-warm-oil-portrait-canvas-print-lab-dog-owner-gift-pet-wall-art-decor-for-home.jpg?v=1784731141',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/labrador-retriever-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-labrador-retriever-lover-gift-stretched-canvas.jpg?v=1784732986',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/labrador-retriever-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-labrador-retriever-lover-gift-stretched-canvas.jpg?v=1784732425'
  },
  dachshund: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/dachshund-stretched-canvas-wall-art-acrylic-painting-dog-print-pet-portrait-gift-for-dog-lovers-modern-animal-home-decor.jpg?v=1784733738',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/1928239708515202909_2048.jpg?v=1784846453',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/dachshund-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-dachshund-lover-gift-stretched-canvas.jpg?v=1784732758',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/dachshund-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-dachshund-lover-gift-stretched-canvas.jpg?v=1784732201'
  },
  corgi: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/corgi-acrylic-painting-canvas-wall-art-dog-lover-gift-stretched-canvas-print-cute-pet-home-decor-animal-art.jpg?v=1784733752',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/10043582161985116608_2048.jpg?v=1784845231',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/pembroke-welsh-corgi-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-pembroke-welsh-corgi-lover-gift-stretched-canvas.jpg?v=1784732963',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/pembroke-welsh-corgi-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-pembroke-welsh-corgi-lover-gift-stretched-canvas.jpg?v=1784732400'
  },
  rottweiler: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/rottweiler-painting-canvas-wall-art-dog-lover-gift-pet-portrait-acrylic-original-style-print-home-decor-stretched-canvas.jpg?v=1784733603',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/rottweiler-oil-portrait-canvas-print-warm-dog-wall-art-pet-lover-gift-gentle-giant-home-decor.jpg?v=1784731039',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/rottweiler-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-rottweiler-lover-gift-stretched-canvas.jpg?v=1784732543',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/rottweiler-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-rottweiler-lover-gift-stretched-canvas.jpg?v=1784731992'
  },
  beagle: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/beagle-wall-art-canvas-print-dog-mom-gift-acrylic-painting-pet-portrait-stretched-canvas-decor-ready-to-hang-dog-lover-art.jpg?v=1784733831',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/beagle-oil-portrait-canvas-wall-art-dog-lover-gift-pet-decor-stretched-canvas-print-ideal-for-beagle-moms-dads.jpg?v=1784731442',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/beagle-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-beagle-lover-gift-stretched-canvas.jpg?v=1784732917',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/beagle-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-beagle-lover-gift-stretched-canvas.jpg?v=1784732354'
  },
  australian_shepherd: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/australian-shepherd-canvas-wall-art-print-aussie-dog-lover-gift-dog-art-home-decor-stretched-acrylic-painting-style.jpg?v=1784733845',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/16129401957316397247_2048.jpg?v=1784845073',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/australian-shepherd-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-australian-shepherd-lover-gift-stretched-canvas.jpg?v=1784732939',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/australian-shepherd-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-australian-shepherd-lover-gift-stretched-canvas.jpg?v=1784732377'
  },
  english_bulldog: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/english-bulldog-canvas-wall-art-print-dog-lover-gift-pet-portrait-modern-acrylic-painting-decor.jpg?v=1784734267',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/english-bulldog-oil-portrait-canvas-print-bulldog-wall-art-dog-lover-gift-pet-portrait-home-decor.jpg?v=1784731285',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/english-bulldog-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-english-bulldog-lover-gift-stretched-canvas.jpg?v=1784732734',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/english-bulldog-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-english-bulldog-lover-gift-stretched-canvas.jpg?v=1784732179'
  },
  poodle: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/poodle-acrylic-art-print-stretched-canvas-wall-art-dog-lover-gift-modern-pet-portrait-home-decor-unique-dog-mom-gift.jpg?v=1784733637',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/poodle-oil-portrait-canvas-print-elegant-dog-wall-art-poodle-lover-gift-sophisticated-pet-decor.jpg?v=1784731077',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/poodle-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-poodle-lover-gift-stretched-canvas.jpg?v=1784732566',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/poodle-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-poodle-lover-gift-stretched-canvas.jpg?v=1784732015'
  },
  boxer: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boxer-dog-painting-stretched-canvas-wall-art-modern-pet-decor-boxer-mom-dad-gift-acrylic-dog-art-print.jpg?v=1784733792',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/13500962269027528519_2048.jpg?v=1784845562',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boxer-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-boxer-lover-gift-stretched-canvas.jpg?v=1784732820',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boxer-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-boxer-lover-gift-stretched-canvas.jpg?v=1784732262'
  },
  border_collie: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/border-collie-canvas-wall-art-dog-lover-gift-pet-portrait-print-acrylic-painting-style-animal-home-decor.jpg?v=1784733818',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/border-collie-oil-portrait-wall-art-canvas-dog-lover-gift-pet-decor-stretched-canvas-print-animal-art-for-home.jpg?v=1784731400',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/border-collie-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-border-collie-lover-gift-stretched-canvas.jpg?v=1784732871',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/border-collie-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-border-collie-lover-gift-stretched-canvas.jpg?v=1784732308'
  },
  great_dane: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/great-dane-canvas-wall-art-dog-lover-gift-acrylic-painting-style-pet-portrait-home-decor-stretched-canvas-print.jpg?v=1784734321',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/great-dane-oil-portrait-canvas-art-stretched-dog-wall-decor-pet-lover-gift-warm-painting-print.jpg?v=1784731184',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/great-dane-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-great-dane-lover-gift-stretched-canvas.jpg?v=1784732673',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/great-dane-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-great-dane-lover-gift-stretched-canvas.jpg?v=1784732122'
  },
  shih_tzu: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/shih-tzu-art-print-dog-wall-art-canvas-pet-lover-gift-acrylic-painting-style-stretched-canvas-decor-dog-mom-present.jpg?v=1784733587',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/shih-tzu-oil-painting-canvas-wall-art-warm-dog-portrait-pet-lover-gift-stretched-canvas-decor-for-shih-tzu-owners.jpg?v=1784731017',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/shih-tzu-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-shih-tzu-lover-gift-stretched-canvas.jpg?v=1784732518',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/shih-tzu-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-shih-tzu-lover-gift-stretched-canvas.jpg?v=1784731968'
  },
  boston_terrier: {
    acrylic: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boston-terrier-wall-art-canvas-print-dog-lover-gift-pet-portrait-acrylic-painting-home-decor-cute-animal-art-gift.jpg?v=1784733805',
    oil: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boston-terrier-oil-portrait-canvas-wall-art-dog-lover-gift-pet-memorial-decor-boston-terrier-mom-dad-gift.jpg?v=1784731379',
    royal: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boston-terrier-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-boston-terrier-lover-gift-stretched-canvas.jpg?v=1784732845',
    medieval: 'https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boston-terrier-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-boston-terrier-lover-gift-stretched-canvas.jpg?v=1784732285'
  }
};

// Q2 — the shopper describes their DOG, never the art. Each temperament maps to a
// style behind the scenes and the style is not named until the reveal (Kyle
// 2026-08-09: naming it "ruins the entire surprise"). Every style here covers all
// 17 breeds, so no temperament can dead-end.
const tqVibes = [
  { id: 'regal',   style: 'royal',    glyph: '♛', label: 'Regal. And knows it.',        sub: 'Sits like the furniture is theirs.' },
  { id: 'soft',    style: 'oil',      glyph: '♥', label: 'Soft-hearted, always leaning on you.', sub: 'Shadow, velcro, professional sigher.' },
  { id: 'chaos',   style: 'acrylic',  glyph: '✻', label: 'Pure colour and chaos.',      sub: 'Zoomies. Every day. No notes.' },
  { id: 'brave',   style: 'medieval', glyph: '⚔', label: 'Brave. Ridiculous. Both.',    sub: 'Guards the house from the mailman and the vacuum.' }
];

// Q3 — what the piece is FOR. Sets the tone of the reveal and the order we look
// for a surface. It deliberately does NOT name a product; the old step asked
// "where should it live" with Canvas / Blanket / Coaster on the cards, which is
// the shopper doing our job for us.
const tqOccasions = [
  // ⚠ 2026-08-09: these orders started identical, and a 272-path simulation showed
  // every single route returning a CANVAS — which made Q3 decorative. It now moves
  // the answer without ever naming a product to the shopper.
  { id: 'just_because', branch: 'self', label: 'Just because.',            sub: "They're family. That's the whole reason.",
    order: ['canvas','blanket','mug','coaster','sticker','phone_case'] },
  { id: 'gift',         branch: 'gift', label: "A gift for someone who's obsessed.", sub: 'Ready to give, no guessing.',
    order: ['blanket','canvas','mug','coaster','sticker','phone_case'] },
  { id: 'memory',       branch: 'self', label: 'In memory of a good one.',  sub: 'Something to keep.',
    order: ['canvas','blanket'] },
  { id: 'new_puppy',    branch: 'self', label: 'A new one just moved in.',  sub: 'Start the wall early.',
    order: ['mug','canvas','sticker','coaster','blanket','phone_case'] }
];

let tqState = {
  step: 0,
  vibe: null,
  occasion: null,
  breed: null,
  other_breed_text: null,
  is_request: false,
  requested_breed_label: '',
  referred_via_share: false,
  branch: null,
  style: null,
  surface: null,
  firstName: '',
  email: '',
  anonId: localStorage.getItem('tq_anon_id') || ('anon-' + Math.random().toString(36).substring(2, 15))
};
localStorage.setItem('tq_anon_id', tqState.anonId);

try {
  const saved = localStorage.getItem(TQ_STATE_KEY + '_progress');
  if (saved) {
    const parsed = JSON.parse(saved);
    if (parsed && parsed.step && parsed.step < 5) Object.assign(tqState, parsed);
  }
} catch (e) {}

function tqPersistProgress() {
  try {
    const { step, breed, other_breed_text, is_request, requested_breed_label, branch, style, surface, anonId } = tqState;
    localStorage.setItem(TQ_STATE_KEY + '_progress',
      JSON.stringify({ step, breed, other_breed_text, is_request, requested_breed_label, branch, style, surface, anonId }));
  } catch (e) {}
}

const tqBreeds = [
  // Available breeds (17 — 12 original + 5 added 2026-05-16: Boxer, Border Collie, Great Dane, Shih Tzu, Boston Terrier)
  { id: 'golden_retriever',    label: 'Golden Retriever',    available: true  },
  { id: 'french_bulldog',      label: 'French Bulldog',      available: true  },
  { id: 'siberian_husky',      label: 'Siberian Husky',      available: true  },
  { id: 'german_shepherd',     label: 'German Shepherd',     available: true  },
  { id: 'labrador',            label: 'Labrador',            available: true  },
  { id: 'dachshund',           label: 'Dachshund',           available: true  },
  { id: 'corgi',               label: 'Corgi',               available: true  },
  { id: 'rottweiler',          label: 'Rottweiler',          available: true  },
  { id: 'beagle',              label: 'Beagle',              available: true  },
  { id: 'australian_shepherd', label: 'Aussie Shepherd',     available: true  },
  { id: 'english_bulldog',     label: 'English Bulldog',     available: true  },
  { id: 'poodle',              label: 'Poodle',              available: true  },
  // Wishlist (1 + Other) — request flow
  { id: 'boxer',               label: 'Boxer',               available: true  },
  { id: 'border_collie',       label: 'Border Collie',       available: true  },
  { id: 'pug',                 label: 'Pug',                 available: false },
  { id: 'great_dane',          label: 'Great Dane',          available: true  },
  { id: 'shih_tzu',            label: 'Shih Tzu',            available: true  },
  { id: 'boston_terrier',      label: 'Boston Terrier',      available: true  },
  { id: 'other',               label: 'Another breed',       available: false }
];

const tqStyles = [
  { id: 'acrylic', label: 'Acrylic', micro: "internal" },
  { id: 'oil', label: 'Oil Portrait', micro: "internal" },
  { id: 'royal', label: 'Royal Portrait', micro: "internal" },
  { id: 'medieval', label: 'Medieval Knight', micro: "internal" }
];

document.addEventListener('DOMContentLoaded', () => {
  tqInitBreedGrid();
  tqInitVibeList();
  tqInitOccasionList();
  const back = document.getElementById('tqBackBtn');
  if (back) back.addEventListener('click', tqBackStep);

  // Deep-link via share: ?breed=<id>&via=share auto-routes to request flow
  const params = new URLSearchParams(window.location.search);
  const deepBreed = params.get('breed');
  const via = params.get('via');
  if (deepBreed) {
    const found = tqBreeds.find(b => b.id === deepBreed);
    if (found && !found.available && found.id !== 'other') {
      setTimeout(() => {
        tqState.breed = found.id;
        tqState.is_request = true;
        tqState.requested_breed_label = found.label;
        if (via === 'share') tqState.referred_via_share = true;
        tqFireStartedQuizEvent();
        tqGoToRequestForm();
      }, 200);
      return;
    }
  }

  if (tqState.step && tqState.step >= 1 && tqState.step <= 4 && !tqState.is_request) {
    tqNextStep(tqState.step);
  }
});

function tqInitBreedGrid() {
  const grid = document.getElementById('breedGrid');
  if (!grid) return;
  grid.innerHTML = '';

  // Eager-load the first 8 tiles (above-the-fold on mobile + desktop). Rest lazy.
  let eagerBudget = 8;

  tqBreeds.forEach(b => {
    const tile = document.createElement('button');
    tile.type = 'button';
    tile.className = 'tq-tile tq-tile--breed';
    if (!b.available && b.id !== 'other') tile.classList.add('tq-tile--coming-soon');
    if (b.id === 'other') tile.classList.add('tq-tile--other');
    tile.setAttribute('aria-label', b.label + (b.available ? '' : ' (coming soon)'));
    tile.onclick = () => tqSelectBreed(b.id, tile);

    if (b.id === 'other') {
      tile.innerHTML = `
        <div class="tq-tile__other-inner">
          <span class="tq-tile__other-plus" aria-hidden="true">+</span>
          <span class="tq-tile__other-label">${b.label}</span>
        </div>
      `;
    } else {
      const img = tqBreedPhotos[b.id] || '';
      const badge = b.available ? '' : '<span class="tq-tile__badge">Coming soon</span>';
      const loadAttr = eagerBudget > 0 ? 'eager" fetchpriority="high' : 'lazy';
      if (eagerBudget > 0) eagerBudget--;
      // A breed with no photo gets a styled monogram plate, never src="" (a broken-image
      // glyph shipped live twice because a repair pass assumed this branch existed).
      const media = img
        ? `<img class="tq-tile__img" src="${img}" alt="${b.label}" loading="${loadAttr}" decoding="async">`
        : `<div class="tq-tile__img tq-tile__img--monogram" role="img" aria-label="${b.label}"
                style="display:flex;align-items:center;justify-content:center;height:100%;
                       background:#1A233A;color:#C5A059;
                       font-family:'Fraunces','Cormorant Garamond',serif;font-size:44px;">${b.label.charAt(0)}</div>`;
      tile.innerHTML = `
        <div class="tq-tile__img-wrap">
          ${media}
          ${badge}
        </div>
        <div class="tq-tile__label">${b.label}</div>
      `;
    }
    grid.appendChild(tile);
  });
}

function tqInitVibeList() {
  const list = document.getElementById('vibeList');
  if (!list) return;
  list.innerHTML = '';
  tqVibes.forEach(v => {
    const item = document.createElement('button');
    item.type = 'button';
    item.className = 'tq-list-item tq-list-item--vibe';
    item.setAttribute('data-vibe', v.id);
    item.onclick = () => tqSelectVibe(v.id, item);
    item.innerHTML = `
      <div class="tq-list-item__glyph" aria-hidden="true">${v.glyph}</div>
      <div class="tq-list-item__main">
        <div class="tq-list-item__label">${v.label}</div>
        <div class="tq-list-item__sub">${v.sub}</div>
      </div>
      <div class="tq-list-item__arrow" aria-hidden="true">→</div>
    `;
    list.appendChild(item);
  });
}

function tqInitOccasionList() {
  const list = document.getElementById('occasionList');
  if (!list) return;
  list.innerHTML = '';
  tqOccasions.forEach(o => {
    const item = document.createElement('button');
    item.type = 'button';
    item.className = 'tq-list-item';
    item.setAttribute('data-occasion', o.id);
    item.onclick = () => tqSelectOccasion(o.id, item);
    item.innerHTML = `
      <div class="tq-list-item__main">
        <div class="tq-list-item__label">${o.label}</div>
        <div class="tq-list-item__sub">${o.sub}</div>
      </div>
      <div class="tq-list-item__arrow" aria-hidden="true">→</div>
    `;
    list.appendChild(item);
  });
}

function tqSelectVibe(vibeId, el) {
  el.parentElement.querySelectorAll('.tq-list-item').forEach(t => t.classList.remove('selected'));
  el.classList.add('selected');
  const v = tqVibes.find(x => x.id === vibeId);
  tqState.vibe = vibeId;
  tqState.style = v ? v.style : null;   // hidden from the shopper on purpose
  setTimeout(() => tqNextStep(3), 320);
}

function tqSelectOccasion(occId, el) {
  el.parentElement.querySelectorAll('.tq-list-item').forEach(t => t.classList.remove('selected'));
  el.classList.add('selected');
  const o = tqOccasions.find(x => x.id === occId);
  tqState.occasion = occId;
  tqState.branch = o ? o.branch : 'self';
  tqState.surface = 'auto';
  setTimeout(() => tqNextStep(5), 320);
}

/* tqUpdateStyleGrid removed 2026-08-09 — Q2 no longer shows the art. Showing five
   pieces and asking "which style" is what gave the answer away before we could. */

function tqShowStep(stepId) {
  document.querySelectorAll('.tq-step').forEach(el => el.classList.remove('active'));
  const target = document.getElementById('step' + stepId);
  if (target) target.classList.add('active');
}

function tqNextStep(targetStep) {
  tqShowStep(targetStep);
  tqState.step = targetStep;

  const header = document.getElementById('tqHeader');
  if (header) {
    if (typeof targetStep === 'number' && targetStep > 0 && targetStep <= 5) {
      header.style.display = 'flex';
      const back = document.getElementById('tqBackBtn');
      if (back) back.style.display = (targetStep === 1) ? 'none' : 'inline-flex';
      const fill = document.getElementById('tqProgressFill');
      if (fill) fill.style.width = (Math.min(targetStep, 4) * 25) + '%';
    } else {
      header.style.display = 'none';
    }
  }
  if (typeof targetStep === 'number' && targetStep <= 4) tqPersistProgress();
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function tqGoToRequestForm() {
  document.querySelectorAll('[data-fill-breed]').forEach(el => { el.innerText = tqState.requested_breed_label; });
  tqShowStep('R5');
  const header = document.getElementById('tqHeader');
  if (header) {
    header.style.display = 'flex';
    const back = document.getElementById('tqBackBtn');
    if (back) back.style.display = 'inline-flex';
    const fill = document.getElementById('tqProgressFill');
    if (fill) fill.style.width = '70%';
  }
  setTimeout(() => {
    const inp = document.getElementById('tqRequestEmail');
    if (inp) inp.focus();
  }, 100);
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function tqGoToRequestThanks() {
  document.querySelectorAll('[data-fill-breed]').forEach(el => { el.innerText = tqState.requested_breed_label; });
  const slug = tqState.breed === 'other'
    ? tqState.requested_breed_label.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')
    : tqState.breed;
  const shareUrl = `https://shoptritan.com/pages/quiz?breed=${encodeURIComponent(slug)}&via=share`;
  const linkEl = document.getElementById('tqShareLink');
  if (linkEl) linkEl.value = shareUrl;
  tqShowStep('R6');
  document.getElementById('tqHeader').style.display = 'none';
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function tqBackStep() {
  // From R5 (request form), reset request state and go back to Q1
  if (tqState.step === 'R5') {
    tqState.is_request = false;
    tqState.requested_breed_label = '';
    tqState.breed = null;
    // Clear any selected tiles
    const grid = document.getElementById('breedGrid');
    if (grid) grid.querySelectorAll('.tq-tile').forEach(t => t.classList.remove('selected'));
    // Hide the "Other" input box
    const oic = document.getElementById('otherBreedInputContainer');
    if (oic) oic.style.display = 'none';
    tqNextStep(1);
    return;
  }
  if (typeof tqState.step === 'number' && tqState.step > 1) {
    tqNextStep(tqState.step - 1);
    return;
  }
  // Step 1 back → return to storefront
  if (tqState.step === 1) {
    window.location.href = '/';
  }
}

// Warm the hero image for every style a temperament can resolve to, so the
// reveal paints instantly. The shopper never sees these until the end — that
// is the point (2026-08-09).
function tqPrefetchStyleHeroes(breedId) {
  if (!breedId || breedId === 'other') return;
  tqVibes.map(function(v){ return v.style; }).forEach(function(sid) {
    var url = (tqStyleHeroes[breedId] && tqStyleHeroes[breedId][sid])
           || (tqStyleHeroes.golden_retriever && tqStyleHeroes.golden_retriever[sid])
           || tqBreedPhotos.golden_retriever;
    if (!url) return;
    var img = new Image();
    img.decoding = 'async';
    img.src = url;
  });
}

function tqSelectBreed(breedId, el) {
  const grid = document.getElementById('breedGrid');
  grid.querySelectorAll('.tq-tile').forEach(t => t.classList.remove('selected'));
  el.classList.add('selected');
  tqState.breed = breedId;

  if (breedId === 'other') {
    document.getElementById('otherBreedInputContainer').style.display = 'block';
    setTimeout(() => {
      const input = document.getElementById('otherBreedInput');
      if (input) input.focus();
    }, 50);
    return;
  }

  document.getElementById('otherBreedInputContainer').style.display = 'none';
  tqState.other_breed_text = null;

  const breedDef = tqBreeds.find(b => b.id === breedId);
  if (breedDef && !breedDef.available) {
    tqState.is_request = true;
    tqState.requested_breed_label = breedDef.label;
    tqFireStartedQuizEvent();
    setTimeout(() => tqGoToRequestForm(), 320);
    return;
  }

  tqState.is_request = false;
  tqFireStartedQuizEvent();
  tqPrefetchStyleHeroes(breedId);            // warm the reveal image cache
  const q2n = document.getElementById('q2BreedName');
  // "What's Golden Retriever like?" reads like a stranger's name. The article is
  // what makes it sound like their dog.
  if (q2n && breedDef) q2n.innerText = 'your ' + breedDef.label;
  setTimeout(() => tqNextStep(2), 320);
}

function tqConfirmOtherBreed() {
  const val = document.getElementById('otherBreedInput').value.trim();
  if (!val) {
    document.getElementById('breedError').style.display = 'block';
    return;
  }
  document.getElementById('breedError').style.display = 'none';
  tqState.other_breed_text = val;
  tqState.is_request = true;
  tqState.requested_breed_label = val;
  tqFireStartedQuizEvent();
  tqGoToRequestForm();
}

/* tqSelectBranch removed 2026-08-09 — absorbed by the occasion question. */

/* tqSelectStyle removed 2026-08-09 — the shopper no longer picks a style. */

/* tqSelectSurface removed 2026-08-09 — the surface question WAS the product picker. */

function tqGetKlaviyoProfileProperties(matchedProduct) {
  const props = {
    quiz_breed:   tqState.breed === 'other' ? tqState.other_breed_text : tqState.breed,
    quiz_style:   tqState.style,
    quiz_surface: tqState.surface,
    quiz_branch:  tqState.branch,
    $source:      'quiz'
  };
  if (tqState.breed === 'other') props.quiz_other_breed_text = tqState.other_breed_text;
  if (matchedProduct) {
    props.quiz_product_title  = matchedProduct.title;
    props.quiz_product_url    = matchedProduct.url;
    props.quiz_product_image  = matchedProduct.image;
    props.quiz_product_handle = matchedProduct.handle;
  }
  if (tqState.firstName) props.$first_name = tqState.firstName;
  return props;
}

function tqFireStartedQuizEvent() {
  if (sessionStorage.getItem('tq_started_fired')) return;
  const payload = {
    data: { type: 'event', attributes: {
      metric: { data: { type: 'metric', attributes: { name: 'Started Quiz' } } },
      profile: { data: { type: 'profile', attributes: {
        external_id: tqState.anonId,
        properties: { $source: 'quiz' }
      } } },
      properties: { breed: tqState.breed === 'other' ? tqState.other_breed_text : tqState.breed },
      time: new Date().toISOString()
    } }
  };
  sessionStorage.setItem('tq_started_fired', 'true'); // klaviyo removed 2026-08-18
}

async function tqSubmit() {
  tqState.firstName = document.getElementById('tqFirstName').value.trim();
  tqState.email     = document.getElementById('tqEmail').value.trim();

  if (!tqState.email || !/^\S+@\S+\.\S+$/.test(tqState.email)) {
    document.getElementById('tqEmailError').style.display = 'block';
    return;
  }
  document.getElementById('tqEmailError').style.display = 'none';

  const btn = document.getElementById('tqSubmitBtn');
  btn.innerText = 'Matching your piece…';
  btn.disabled = true;

  const matchedProduct = tqGetMatchedProduct(tqState.breed, tqState.style, tqState.surface);
  const profileProps = tqGetKlaviyoProfileProperties(matchedProduct);
  const consentEl = document.getElementById('tqConsent');
  const consentChecked = consentEl ? consentEl.checked : true;

  if (consentChecked) {
    try {
      // klaviyo removed 2026-08-18: consented quiz emails now become Shopify
      // customers, which fires the welcome automation (code TRITAN25)
      const fd = new URLSearchParams();
      fd.append('form_type', 'customer');
      fd.append('utf8', '\u2713');
      fd.append('contact[email]', tqState.email);
      fd.append('contact[tags]', 'newsletter,quiz');
      await fetch('/contact', { method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: fd });
    } catch (e) { console.error('subscribe error:', e); }
  }

  try {
    localStorage.setItem(TQ_STATE_KEY, JSON.stringify(tqState));
    localStorage.removeItem(TQ_STATE_KEY + '_progress');
  } catch (e) {}

  const handle = (matchedProduct && matchedProduct.handle) || 'bestsellers';
  window.location.href = `/pages/quiz-results?handle=${encodeURIComponent(handle)}`;
}

function tqSkipEmail() {
  const matchedProduct = tqGetMatchedProduct(tqState.breed, tqState.style, tqState.surface);
  try {
    localStorage.setItem(TQ_STATE_KEY, JSON.stringify(tqState));
    localStorage.removeItem(TQ_STATE_KEY + '_progress');
  } catch (e) {}
  const handle = (matchedProduct && matchedProduct.handle) || 'bestsellers';
  window.location.href = `/pages/quiz-results?handle=${encodeURIComponent(handle)}`;
}

async function tqSubmitRequest() {
  const firstName = document.getElementById('tqRequestFirstName').value.trim();
  const email = document.getElementById('tqRequestEmail').value.trim();
  if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
    document.getElementById('tqRequestEmailError').style.display = 'block';
    return;
  }
  document.getElementById('tqRequestEmailError').style.display = 'none';

  const btn = document.getElementById('tqRequestSubmitBtn');
  btn.innerText = 'Adding your vote…';
  btn.disabled = true;

  tqState.firstName = firstName;
  tqState.email = email;

  const breedSlug = tqState.breed === 'other'
    ? tqState.requested_breed_label.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')
    : tqState.breed;

  const props = {
    requested_breed: tqState.requested_breed_label,
    requested_breed_slug: breedSlug,
    referred_via_share: !!tqState.referred_via_share,
    $source: 'quiz_breed_request'
  };
  if (firstName) props.$first_name = firstName;

  const consentEl = document.getElementById('tqRequestConsent');
  const consentChecked = consentEl ? consentEl.checked : true;
  if (consentChecked) {
    const payload = {
      data: { type: 'event', attributes: {
        metric: { data: { type: 'metric', attributes: { name: 'Requested Breed' } } },
        profile: { data: { type: 'profile', attributes: {
          email: email,
          first_name: firstName,
          external_id: tqState.anonId,
          properties: props
        } } },
        properties: props,
        time: new Date().toISOString()
      } }
    };
    try {
      const fd = new URLSearchParams();
      fd.append('form_type', 'customer');
      fd.append('utf8', '\u2713');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', 'newsletter,quiz,breed-request');
      await fetch('/contact', { method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: fd });
    } catch (e) { console.error('subscribe error:', e); }
  }

  try { localStorage.removeItem(TQ_STATE_KEY + '_progress'); } catch (e) {}
  tqGoToRequestThanks();
}

function tqShareBreed() {
  const url = document.getElementById('tqShareLink').value;
  const breed = tqState.requested_breed_label;
  const text = `Help launch the ${breed} collection at Tritan — if enough of us ask, they'll add it.`;
  if (navigator.share) {
    navigator.share({
      title: `Get ${breed} portraits made at Tritan`,
      text: text,
      url: url
    }).catch(() => {});
  } else {
    tqCopyShareLink();
  }
}

function tqCopyShareLink() {
  const linkEl = document.getElementById('tqShareLink');
  linkEl.select();
  linkEl.setSelectionRange(0, 99999);
  try {
    navigator.clipboard.writeText(linkEl.value);
    const btn = document.getElementById('tqCopyBtn');
    if (btn) {
      const orig = btn.innerText;
      btn.innerText = '✓ Copied!';
      btn.disabled = true;
      setTimeout(() => { btn.innerText = orig; btn.disabled = false; }, 2200);
    }
  } catch (e) {
    document.execCommand('copy');
  }
}

function tqGetMatchedProduct(breed, style, surface) {
  if (typeof tritanQuizLookup === 'undefined') return null;
  const breedData = tritanQuizLookup[breed];
  if (!breedData) return null;

  // 2026-08-09: this used to fall through four levels — same style/other surface,
  // then ANY style — and return the product with no indication that it was not
  // what the shopper picked. The reveal then claimed it was their match. Now the
  // fallback is still there (a dead end is worse) but it is LABELLED, and the
  // results page says so out loud. Same law as the cart drawer's cross-sell
  // heading: never assert more than the matching logic guarantees.
  const occ = (typeof tqOccasions !== 'undefined')
    ? tqOccasions.find(o => o.id === tqState.occasion) : null;
  const order = (occ && occ.order) ? occ.order
    : ['canvas','blanket','mug','coaster','sticker','phone_case'];

  const tag = (p, exactStyle, actualStyle) =>
    Object.assign({}, p, { _exactStyle: exactStyle, _actualStyle: actualStyle });

  if (breedData[style]) {
    for (const k of order) if (breedData[style][k]) return tag(breedData[style][k], true, style);
    for (const k of Object.keys(breedData[style])) if (k !== 'mug') return tag(breedData[style][k], true, style);
  }
  for (const s in breedData) {
    for (const k of order) if (breedData[s][k]) return tag(breedData[s][k], false, s);
  }
  for (const s in breedData) {
    for (const k in breedData[s]) if (k !== 'mug') return tag(breedData[s][k], false, s);
  }
  return null;
}
